exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/naptimejs.js-WebpackMultiOutput";